<app-processing [visible]="!pageVars.isReady"></app-processing>

<h3>Primary Maintenance Lists</h3>
<div class="flex flex-wrap align-items-center justify-content-start gap-2">
  <p-card *ngFor="let lookup of primaryList" class="function-card">
    <ng-template pTemplate="header">
      <div class="flex mt-1 ml-2">
        <h4 class="pl-1">{{ lookup.title }}</h4>
      </div>
    </ng-template>
    <p style="font-size: small; height: 5rem">
      {{ lookup.description }}
    </p>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end">
        <p-button
          label="Go"
          [raised]="true"
          iconPos="right"
          size="small"
          icon="fa fa-angles-right"
          (click)="goClick(lookup.path)"
          attr.data-testid="go {{ lookup.title }}"></p-button>
      </div>
    </ng-template>
  </p-card>
</div>
<hr class="category-break" />
<h3>Secondary Maintenance Lists</h3>
<div class="flex flex-wrap align-items-center justify-content-start gap-2">
  <p-card *ngFor="let lookup of secondaryList" class="function-card">
    <ng-template pTemplate="header">
      <div class="flex mt-1 ml-2">
        <h4 class="pl-1">{{ lookup.title }}</h4>
      </div>
    </ng-template>
    <p style="font-size: small; height: 5rem">
      {{ lookup.description }}
    </p>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end">
        <p-button
          label="Go"
          [raised]="true"
          iconPos="right"
          size="small"
          icon="fa fa-angles-right"
          (click)="goClick(lookup.path)"
          attr.data-testid="go {{ lookup.title }}"></p-button>
      </div>
    </ng-template>
  </p-card>
</div>
